/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Readable } from '../../models/readable';

export interface DataControllerVisuals$Params {
  visualId: string;
  fileType: 'svg';
}

export function dataControllerVisuals(http: HttpClient, rootUrl: string, params: DataControllerVisuals$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
  const rb = new RequestBuilder(rootUrl, dataControllerVisuals.PATH, 'get');
  if (params) {
    rb.path('visualId', params.visualId, {});
    rb.path('fileType', params.fileType, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/svg+xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Readable>;
    })
  );
}

dataControllerVisuals.PATH = '/planning-projects/v1-develop/data/visuals/{visualId}/{fileType}';
